import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isToolbarVisible: false,
    isToolbarVisibleCell: false,
    isFooterVisible: true,
    planosPF: [],
    planosSP: [],
    planosPJ: [],
    userloggedin: false

  },
  mutations: {
    exibetoolbar(state){
      state.isToolbarVisible = true;
    },
    escondetoolbar(state){
      state.isToolbarVisible = false;
    },
    exibetoolbarcell(state){
      state.isToolbarVisibleCell = true;
    },
    escondetoolbarcell(state){
      state.isToolbarVisibleCell = false;
    },
    escondefooter(state){
      state.isFooterVisible = false;
    },
    exibefooter(state){
      state.isFooterVisible = true;
    },
    carregadadosplanopf(state,planosPF){
      state.planosPF = planosPF
      //console.log(state.planosPF)
    },
    carregadadosplanosp(state,planosSP){
      state.planosSP = planosSP
      //console.log(state.planosPF)
    },
    carregadadosplanopj(state,planosPJ){
      state.planosPJ = planosPJ
      //console.log(state.planosPF)
    },
    logar(state) {  
      if(sessionStorage.getItem('email') != null)                                
      state.userloggedin = true 
      else
      state.userloggedin = false           
    },
    sair(state){
      localStorage.clear()
      sessionStorage.clear()
      state.userloggedin = false 
    },

  },
  actions: {
    ExibeToolbar({commit}){
      commit("exibetoolbar");
    },
    EscondeToolbar({commit}){
      commit("escondetoolbar");
    },
    ExibeToolbarCell({commit}){
      commit("exibetoolbarcell");
    },
    EscondeToolbarCell({commit}){
      commit("escondetoolbarcell");
    },
    ExibeFooter({commit}){
      commit("exibefooter");
    },
    EscondeFooter({commit}){
      commit("escondefooter");
    },
    planosPF(context, payload){
      context.commit('carregadadosplanopf', payload);
    },
    planosSP(context, payload){
      context.commit('carregadadosplanosp', payload);
    },
    planosPJ(context, payload){
      context.commit('carregadadosplanopf', payload);
    },
    Logar({commit}){
      commit("logar");
    },
    Sair({commit}){
      commit("sair");
    }
  }
})
